import React from 'react';
import styles from './css/index.module.css';
import { Input } from '@fluentui/react-components';
import { ChevronDown16Regular, Search20Regular } from '@fluentui/react-icons';
import { PatchProjectData } from '../../redux/projectDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
const AddPublicProfiles = ({ setSelectedView, createdProjectData }) => {
    const dispatch = useDispatch();

    const { projectDetailButtonLoading } = useSelector(state => state.projectData);
    const [formData, setFormData] = React.useState({
        crunchbase: '',
        endole: '',
        glassdoor: '',
    });

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleSubmit = async () => {
        await dispatch(
            PatchProjectData({
                data: formData,
                id: createdProjectData?.id,
            }),
        );

        setSelectedView('competitors');
    };
    const handleSearchOnWeb = platform => {
        let withoutSpecialChracterString = createdProjectData?.company_name.replace(/[^a-zA-Z0-9\s]/g, '');
        const searchQuery = (withoutSpecialChracterString + ' ' + platform).replace(' ', '+');
        window.open(`https://www.google.com/search?q=${searchQuery}`, '_blank');
    };

    return (
        <div className={styles.componentCard}>
            <h5 className={styles.componentTitle}>Add public profiles</h5>
            <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={styles.fieldLabel}>Crunchbase profile</p>
                    <Search20Regular onClick={() => handleSearchOnWeb('Crunchbase profile')} role="button" color="var(--Brand-Secondary)" />
                </div>
                <Input className={styles.inputField} value={formData?.crunchbase} onChange={handleChange} name="crunchbase" />
            </div>

            <div className="mb-4">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={styles.fieldLabel}>Glassdoor profile</p>
                    <Search20Regular onClick={() => handleSearchOnWeb('Glassdoor profile')} role="button" color="var(--Brand-Secondary)" />
                </div>
                <Input className={styles.inputField} value={formData?.glassdoor} onChange={handleChange} name="glassdoor" />
            </div>
            <div className="mb-5">
                <div className="d-flex align-items-center justify-content-between">
                    <p className={styles.fieldLabel}>Endole profile</p>
                    <Search20Regular onClick={() => handleSearchOnWeb('Endole profile')} role="button" color="var(--Brand-Secondary)" />
                </div>
                <Input className={styles.inputField} value={formData?.endole} onChange={handleChange} name="endole" />
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <button onClick={handleSubmit} className={styles.submitButton}>
                    Confirm {projectDetailButtonLoading && <AiOutlineLoading3Quarters className="ms-2 rotateLoader" />}
                </button>
                <span onClick={() => setSelectedView('competitors')} className={styles.linkBtn}>
                    Skip
                </span>
            </div>
        </div>
    );
};

export default AddPublicProfiles;
